export default __webpack_public_path__ + "static/media/Oola_lifestyle_framework_image.f1055c3d.jpeg";